import { render, staticRenderFns } from "./ConfiguracaoGeralEquipamentoCard.vue?vue&type=template&id=56ffc13f&scoped=true&"
import script from "./ConfiguracaoGeralEquipamentoCard.vue?vue&type=script&lang=js&"
export * from "./ConfiguracaoGeralEquipamentoCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56ffc13f",
  null
  
)

export default component.exports